module.exports = __webpack_public_path__ + "media/images/ico-pdf-a86e51de.svg";